import React, { useState } from 'react'
import { Modal } from "react-bootstrap";

const states = {
  setState: null,
  changeState(data) {
    if (!this.setState) return;
    this.setState((prevData) => {
      return {
        ...prevData,
        ...data
      };
    });
  }
};

const handleClose = () => {
  states.changeState({
    open: false
  });
};

const ModalPopUp = () => {
  const [data, setData] = useState({
    open: false,
    header: "ini header default",
    message: "ini message default",
    size: "md",
    onClose: handleClose
  });

  states.setState = setData;

  return (
    <Modal show={data.open} onHide={data.onClose} size={data.size} backdrop="static">
      {data.header && (
        <Modal.Header closeButton>
          <div className="row w-100 m-0">
            <div className="col-10 p-0 text-left">
              <h3 className="modal-title">{data.header}</h3>
            </div>
            <div className="col-2 text-right p-0">
              <button className="btn btn-icon btn-xs btn-hover-light-warning" onClick={data.onClose} type="button">
                <i className="fas fa-times"></i>
              </button>
            </div>
          </div>
        </Modal.Header>
      )}
      <Modal.Body>{data.message}</Modal.Body>
    </Modal>
  );
};

const openModal = ({ message, header, size, open = true, onClose = () => { } }) => {
  states.changeState({
    message,
    header,
    size,
    open: open,
    onClose: () => {
      onClose();
      handleClose();
    }
  });
};

const PopUpMessage = ({ title, message, type, onAction }) => {
  let icons = "fas fa-exclamation-triangle text-danger";
  if (type === "success") {
    icons = "far fa-check-circle text-success"
  } else if (type === "error") {
    icons = "far fa-times-circle text-danger"
  }

  return (
    <div className="text-center py-8">
      <div className="icon mb-5">
        <i
          className={icons}
          style={{ fontSize: "6em" }}
        ></i>
      </div>
      {title && <h1 className="text-dark">{title}</h1>}
      {message && <p className="font-size-lg">{message}</p>}
      {onAction ? (
        <div className="btn-group mt-10">
          <button className="btn btn-lg btn-light" type="button" onClick={() => openModal({ open: false })}>
            Cancel
          </button>
          <button className="btn btn-lg btn-primary" type="button" onClick={onAction}>
            Submit
          </button>
        </div>
      ) : (
        <button className="btn btn-lg btn-primary mt-10" type="button" onClick={() => openModal({ open: false })}>
          Ok, got it!
        </button>
      )}
    </div>
  )
}

export default ModalPopUp;
export { openModal, PopUpMessage };